<template>
    <v-app id="admin-dashboard">
        <!-- Navigation -->
        <admin-navigation :drawer="drawer"></admin-navigation>

        <!-- Toolbar -->
        <admin-toolbar @setDrawer="setDrawer"></admin-toolbar>

        <!-- Content -->
        <v-content>
            <router-view :user="user"></router-view>
        </v-content>

        <!-- Footer -->
        <admin-footer></admin-footer>
    </v-app>
</template>

<script>
import auth from '../../js/auth';
import AdminFooter from '../../components/Admin/Footer';
import AdminNavigation from '../../components/Admin/Navigation';
import AdminToolbar from '../../components/Admin/Toolbar'

export default {
    name: 'admin-dashboard',
    components: {
        AdminFooter,
        AdminNavigation,
        AdminToolbar
    },
    data() {
        return {
            drawer: true,
            user: ''
        }
    },
    methods: {
        getUser() {
            const user = auth.getUser();

            if (user) {
                this.user = user;
            }
        },
        setDrawer() {
            this.drawer = !this.drawer;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        },
        dangerColor() {
            return '#f64e60';
        },
        infoColor() {
            return '#5578eb';
        },
        primaryColor() {
            return '#5867dd';
        },
        secondaryColor() {
            return '#f9f9fc';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    },
    created() {
        this.getUser();
    }
}
</script>

<style>
.v-card,
.v-dialog {
    font-family: 'Poppins', sans-serif !important;
}

.v-content {
    background: #EEF0F8;
}
</style>